import { callAPI, postAPI } from "../services/api";

export const getDraftLog = async (workOrderId, storeId) => {
  try {
    const response = await callAPI(`draftlog/${workOrderId}/${storeId}`);
    return response;
  } catch (error) {
    console.error("Error fetching draft log:", error);
    throw error;
  }
};

export const upsertDraftLog = async (draftLogData) => {
  try {
    const response = await postAPI('', 'draftlog', draftLogData);
    return response;
  } catch (error) {
    console.error("Error upserting draft log:", error);
    throw error;
  }
};
